import { Table } from "../../components/Table/Table";
import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { useAdministration } from "./useAdministration";
import { BrandButton } from "../../components/BrandButton/BrandButton";
import { IoAddCircleOutline } from "react-icons/io5";
import { AddDataSourceModal } from "../../components/AddDataSourceModal/AddDataSourceModal";

export const Administration = () => {
  const {
    columns,
    data,
    isAddDataSourceOpen,
    onAddDataSourceOpen,
    onAddDataSourceClose,
  } = useAdministration();
  return (
    <Box>
      <HStack justifyContent="space-between">
        <Text fontSize="larger" fontWeight="600">
          Data Source
        </Text>
        <BrandButton size="sm" onClick={onAddDataSourceOpen} gap={1}>
          <Icon as={IoAddCircleOutline as React.ElementType} boxSize="22px" />{" "}
          Create
        </BrandButton>
      </HStack>
      <Box borderRadius="md" mt={3}>
        <Table data={data} columns={columns} />
      </Box>

      <AddDataSourceModal
        isOpen={isAddDataSourceOpen}
        onClose={onAddDataSourceClose}
      />
    </Box>
  );
};
